var _path, _polygon, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProgressOutlinedIconWithoutFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-997.85-167.53H-162.2a3.69,3.69,0,0,1,3.69,3.69V206.06a0,0,0,0,1,0,0h-843a0,0,0,0,1,0,0V-163.83a3.69,3.69,0,0,1,3.69-3.69Z",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-717.06,205.16S-524,166.69-442.39,82.52c55.84-57.61,112.55-140.67,221-149.08S28.05,11.16,50.16,95.75c28.91,110.61,9.29,169.53,9.29,169.53Z"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "18.48 25.72 16.48 27.74 22.16 33.49 33.52 22 31.52 19.96 22.16 29.43 18.48 25.72"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.46,9.44h-8a5.72,5.72,0,0,0-10.84,0h-8a3.25,3.25,0,0,0-.77.08,3.77,3.77,0,0,0-1.94,1.07,3.94,3.94,0,0,0-1.14,2.74V40.56a3.94,3.94,0,0,0,1.14,2.76,3.77,3.77,0,0,0,1.94,1.07,4.81,4.81,0,0,0,.77.06H38.46a3.88,3.88,0,0,0,3.85-3.89V13.33A3.88,3.88,0,0,0,38.46,9.44ZM25,9a1.46,1.46,0,1,1-1.44,1.46A1.46,1.46,0,0,1,25,9ZM38.46,40.56H11.54V13.33H38.46Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressOutlinedIconWithoutFill);
export default __webpack_public_path__ + "static/media/progress_outlined_icon_without_fill.c0758def7388e17c94ef175eda5a450e.svg";
export { ForwardRef as ReactComponent };